(function () {
  function syncSlides(swiper) {
    if (!swiper || !swiper.slides) return;

    var mobileView = window.innerWidth <= 768;
    var sliderRect = swiper.el.getBoundingClientRect();
    var sliderCenter = sliderRect.left + sliderRect.width / 2;
    var closestSlide = null;
    var closestDistance = Infinity;

    swiper.slides.forEach(function (slide) {
      var rect = slide.getBoundingClientRect();
      var slideCenter = rect.left + rect.width / 2;
      var distance = Math.abs(slideCenter - sliderCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = slide;
      }
    });

    swiper.slides.forEach(function (slide) {
      var card = slide.querySelector('.lc-product-info-swiper__card');
      if (!card) return;

      var isActive = slide === closestSlide;

      card.style.transform = 'scale(' + (isActive ? 1 : mobileView ? 0.855 : 0.8) + ')';
      slide.style.opacity = '1';
    });
  }

  function scheduleSync(swiper) {
    if (!swiper) return;

    if (swiper.lcProductInfoSyncFrame) {
      cancelAnimationFrame(swiper.lcProductInfoSyncFrame);
    }

    swiper.lcProductInfoSyncFrame = requestAnimationFrame(function () {
      syncSlides(swiper);
      swiper.lcProductInfoSyncFrame = null;
    });
  }

  function initAll(scope) {
    if (typeof Swiper === 'undefined' || !scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('[data-product-info-swiper]').forEach(function (slider) {
      if (slider.swiper) return;

      var imageCount = parseInt(slider.dataset.imageCount || '0', 10);
      var autoplaySpeed = Math.max(parseInt(slider.dataset.autoplaySpeed || '3000', 10), 1000);
      var desktopSlides = imageCount >= 3 ? 3 : Math.max(imageCount, 1);
      var mobileSlides = imageCount > 1 ? 1.32 : 1;
      var staticDesktopGallery = imageCount === 3;
      var desktopCentered = staticDesktopGallery || imageCount > desktopSlides;
      var desktopLoop = imageCount > desktopSlides;
      var desktopInitialSlide = staticDesktopGallery ? 1 : 0;
      var mobileInitialSlide = imageCount > 1 ? Math.floor(imageCount / 2) : 0;
      var autoplayEnabled = slider.dataset.autoplay === 'true' && imageCount > 1 && !staticDesktopGallery;

      new Swiper(slider, {
        slidesPerView: mobileSlides,
        spaceBetween: 0,
        centeredSlides: imageCount > 1,
        loop: imageCount > 1 && !staticDesktopGallery,
        grabCursor: imageCount > 1,
        speed: 600,
        initialSlide: window.innerWidth >= 1200 ? desktopInitialSlide : mobileInitialSlide,
        autoplay: autoplayEnabled
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false
            }
          : false,
        breakpoints: {
          1024: {
            slidesPerView: mobileSlides,
            spaceBetween: 0,
            centeredSlides: imageCount > 1,
            loop: false
          },
          1200: {
            slidesPerView: desktopSlides,
            spaceBetween: 60,
            centeredSlides: desktopCentered,
            loop: desktopLoop,
            allowTouchMove: !staticDesktopGallery
          },
          1600: {
            slidesPerView: desktopSlides,
            spaceBetween: 100,
            centeredSlides: desktopCentered,
            loop: desktopLoop,
            allowTouchMove: !staticDesktopGallery
          }
        },
        on: {
          init: function (swiper) {
            if (window.innerWidth >= 1200 && staticDesktopGallery) {
              swiper.slideTo(desktopInitialSlide, 0, false);
            }
            scheduleSync(swiper);
          },
          setTranslate: function (swiper) {
            scheduleSync(swiper);
          },
          slideChange: function (swiper) {
            scheduleSync(swiper);
          },
          transitionEnd: function (swiper) {
            scheduleSync(swiper);
          },
          resize: function (swiper) {
            if (window.innerWidth >= 1200 && staticDesktopGallery && swiper.activeIndex !== desktopInitialSlide) {
              swiper.slideTo(desktopInitialSlide, 0, false);
            } else if (window.innerWidth < 1200 && swiper.activeIndex !== mobileInitialSlide && !swiper.lcProductInfoMobileCentered) {
              swiper.lcProductInfoMobileCentered = true;
              swiper.slideTo(mobileInitialSlide, 0, false);
            }
            scheduleSync(swiper);
          },
          breakpoint: function (swiper) {
            if (window.innerWidth >= 1200 && staticDesktopGallery && swiper.activeIndex !== desktopInitialSlide) {
              swiper.slideTo(desktopInitialSlide, 0, false);
            } else if (window.innerWidth < 1200 && swiper.activeIndex !== mobileInitialSlide && !swiper.lcProductInfoMobileCentered) {
              swiper.lcProductInfoMobileCentered = true;
              swiper.slideTo(mobileInitialSlide, 0, false);
            }
            scheduleSync(swiper);
          }
        }
      });
    });
  }

  function destroyAll(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('[data-product-info-swiper]').forEach(function (slider) {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
    });
  }

  if (!window.LcProductInfoSwiper) {
    window.LcProductInfoSwiper = {
      initAll: initAll,
      destroyAll: destroyAll
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initAll(document);
        },
        { once: true }
      );
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event.target);
    });
  } else {
    window.LcProductInfoSwiper.initAll(document);
  }
})();
